import React, { useState } from "react";
import { useRoleVerify } from "Common/RoleVerify";
import { getBlogsWithPagination, deleteBlog } from "adminApi/BlogApi/Blog";
import DataTable from "Common/DataTable/DataTable";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import useTableConfig from "Hooks/useTableConfig";
import { generateDisplayFields } from "utils/fieldMapper";
import fields from "../../../json/BlogFields.json";
import { FilterStatus } from "utils/FilterStatus";

const BlogListTable = () => {
    const [search, setSearch] = useState("");
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const debouncedSearch = useDebouncedValue(search, 500);
    const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
    const sizeOptions = [10, 20, 50, 100];
    const { tabledata } = fields;

    const { data, meta, loading, error, refetch } = usePaginatedFetch(getBlogsWithPagination, {
        page,
        limit,
        search: debouncedSearch,
        title: "Blog List",
    });

    const displayFields = generateDisplayFields(tabledata);
    const filteredData = FilterStatus(data);

    const { formattedData, columns } = useTableConfig({
        data: filteredData,
        page,
        limit,
        canShowAction,
        refetch,
        IsDelete: true,
        config: {
            entityName: "Blog",
            editUrl: "edit-blog",
            idKey: "id",
            deleteApi: deleteBlog,
            displayFields,
        },
    });

    const handleSearch = (val, resetPage = null) => {
        setSearch(val);
        if (resetPage !== null) setPage(resetPage);
    };

    return (
        <DataTable
            columns={columns}
            data={formattedData}
            options={{
                loading,
                error,
                sortableColumns: displayFields.map((f) => f.accessor),
                copy: true,
                csv: true,
                pdf: true,
                print: true,
                fileName: "Blogs",
            }}
            Search={{
                search: true,
                SearchInputValue: search,
                handleSearch,
            }}
            Entries={{
                Entries: true,
                limit,
                onLimitChange: (newLimit) => { setLimit(newLimit); setPage(1); },
                options: sizeOptions,
            }}
            pagination={{
                isActive: true,
                meta,
                onPageChange: (p) => setPage(p),
            }}
        />
    );
};

export default BlogListTable;
